// Local progress persistence via localStorage. Nothing is sent to any server.

const KEY = 'tabuada_progress_v1';

let remotePush = null;
export function setRemotePush(fn) {
  remotePush = fn;
}

// Write server data straight to local cache without echoing back to the server.
export function hydrate(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (err) {
    console.warn('Não foi possível hidratar o progresso:', err);
  }
}

function defaultData() {
  return {
    name: '',
    voiceId: 'girl_2',
    volume: 1,
    tables: {}, // { [n]: { learned, answered, correct, wrong, stars } }
    totals: { answered: 0, correct: 0, wrong: 0 },
    bestStreak: 0,
  };
}

export function getProgress() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultData();
    return { ...defaultData(), ...JSON.parse(raw) };
  } catch (err) {
    console.warn('Não foi possível ler o progresso salvo:', err);
    return defaultData();
  }
}

export function saveProgress(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (err) {
    // Storage may be full or unavailable (private mode). Progress simply
    // won't persist this session — not fatal, so we only warn.
    console.warn('Não foi possível salvar o progresso:', err);
  }
  if (remotePush) remotePush(data);
}

export function patchProgress(patch) {
  const cur = getProgress();
  const next = { ...cur, ...patch };
  saveProgress(next);
  return next;
}

function ensureTable(data, n) {
  if (!data.tables[n]) {
    data.tables[n] = { learned: false, answered: 0, correct: 0, wrong: 0, stars: 0 };
  }
  return data.tables[n];
}

export function markLearned(n) {
  const data = getProgress();
  ensureTable(data, n).learned = true;
  saveProgress(data);
  return data;
}

// Record a full session result for a table
export function recordSession(n, { correct, wrong, stars, bestStreak }) {
  const data = getProgress();
  const t = ensureTable(data, n);
  t.answered += correct + wrong;
  t.correct += correct;
  t.wrong += wrong;
  t.stars = Math.max(t.stars, stars);
  data.totals.answered += correct + wrong;
  data.totals.correct += correct;
  data.totals.wrong += wrong;
  data.bestStreak = Math.max(data.bestStreak, bestStreak || 0);
  saveProgress(data);
  return data;
}

export function resetProgress() {
  const data = defaultData();
  saveProgress(data);
  return data;
}
